import { useState } from 'react';

import { useNavigate } from 'react-router-dom'; 

import { createMagicLink, getCurrentUser } from '@/actions/login';

import i18n from '@/i18n'; 
import { Button, Alert, Box, Divider } from '@mui/joy'
import { TextField } from '@/components/InputField';
import { Warning } from '@phosphor-icons/react';
import { Check } from '@phosphor-icons/react';
import { useEffect } from 'react';

export function LoginPage() {

  const navigate = useNavigate()
  const [loggingIn, setLoggingIn] = useState(false)
  const [email, setEmail] = useState('')
  const [loginError, setLoginError] = useState(null)
  const [error, setError] = useState(null)
  const [loggedIn] = useState(false)

  useEffect(() => {
    getCurrentUser().then((data) => {
      if (data) {
        if (!data.code) {
          if(data?.label) {
            navigate(`/dashboard`)
          }
        } else {
          setError(data.code)
        }
      }
    }).catch(e => {
      console.error(e)
      setError(e)
    })
  }, [])

  const handleSubmit = (event) => {
    event.preventDefault()
    setLoggingIn(true)
    localStorage.setItem('email', email);
    createMagicLink(email).then((data) => {
      setLoginError(null)
      setLoggingIn(false)
      navigate(`/accounts/login/link/${data.id}`);
    }).catch(e => {
      console.error(e)
      setLoggingIn(false)
      setLoginError(e)
    })
  }
  return (
    <form method="POST" onSubmit={handleSubmit}>
      <Box sx={{ padding: 1 }}>
        <Box style={{ display: 'flex', gap: 10, width: '100%', alignItems: 'stretch', flexDirection: "column"}}>
          {loginError &&
            <Alert variant="filled" color="danger">
              <Warning size={28} />
              {i18n.t('invalid-username-or-password')}
            </Alert>
          }
          {loggedIn &&
            <Alert variant="filled" color="success">
              <Check size={28} />
              {i18n.t('successfully-logged-in')}
            </Alert>
          }
          <TextField placeholder={i18n.t("email")} onChange={(event) => setEmail(event.target.value)} name="email" variant="standard" label={i18n.t("email")} required={true} />
          <Button aria-label="Login with link" loading={loggingIn} type="submit" variant="solid" color="primary">{loggingIn ? i18n.t('loading') : i18n.t('login-with-link')}</Button>
          <Divider sx={{ '--Divider-childPosition': '50%' }}>{i18n.t('or')}</Divider>
          <Button aria-label="Login with password" variant="outlined" onClick={() => navigate(`/accounts/login/password`)}>{i18n.t('login-with-password')}</Button>
        </Box>
      </Box>
    </form>
  )
}

export default LoginPage;
